import { render, staticRenderFns } from "./organizationDocuments.vue?vue&type=template&id=34b6f3a6&scoped=true&"
import script from "./organizationDocuments.vue?vue&type=script&lang=js&"
export * from "./organizationDocuments.vue?vue&type=script&lang=js&"
import style0 from "./organizationDocuments.vue?vue&type=style&index=0&id=34b6f3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b6f3a6",
  null
  
)

export default component.exports